(function (app) {

    function removeBadScheduledTasksFilter(_, badScheduledTasks) {
        var fn = function (list) {
            var result = list.filter(task => badScheduledTasks.indexOf(task.Id) === -1);
            return result;
        };

        return _.memoize(fn, function (input) { return JSON.stringify(input) });
    }

    removeBadScheduledTasksFilter.$inject = ["_", "badScheduledTasks"];
    app.filter("removeBadScheduledTasksFilter", removeBadScheduledTasksFilter);

})(window.app); //jshint ignore:line